import AxL from '../../axl';
import { AssetLoader } from '../AssetLoader';
import { ClockScene } from '../ClockScene';
import { CreatureManager } from '../CreatureManager';
import { IRWN } from '../IRWN';
import { LandingPageScene } from '../LandingPageScene';
import { FSM } from './FSM';
import {FSM_LOAD_CLOCK,FSM_CLOCK} from './FSM_CLOCK';

const FSM_LOAD_LANDING = FSM.getState(FSM.stateNames.LOAD_LANDING);

FSM_LOAD_LANDING.enter = function() {
  if (AxL.initialData.direct_entry) {
    AssetLoader.queueTexture('./tex/irwn_creatureAtlas.basis');
    AssetLoader.loadQueue(()=>{
      CreatureManager.setupMaterial();

      // No idea ho this works. Copied the code from the landing page's CTA click handler
      FSM.setState(FSM_CLOCK);
      ClockScene.loadScene();
    });
  } else {
    LandingPageScene.load();
  }
};
FSM_LOAD_LANDING.execute = function(dt){
    LandingPageScene.update(dt);
}

export { FSM_LOAD_LANDING };